/** @file Pitch band of a node pitch in degrees: 0..11, band 4 = level (design 4.3). */
import { PITCH_THRESHOLDS } from '@zilo/pose3d-format/tables/pitchThresholds';

/** Band of `pitchDeg`; the pitch is wrapped into [-135, 225) first (below -135 adds 360), the remainder is band 11. */
export function bandOf(pitchDeg: number): number {
  const p = ((((pitchDeg + 135) % 360) + 360) % 360) - 135;
  const i = PITCH_THRESHOLDS.findIndex((t) => p < t);
  return i < 0 ? 11 : i;
}
